module.exports = __webpack_public_path__ + "static/media/storetele724.1b444353.png";